import React, { useState } from 'react';
import { Moment } from 'moment';
import { DatePicker } from 'cdk-radial';

interface DatePickerProps {
  initialDate?: Moment | null;
  label: string;
  id: string;
  name: string;
  errorMessage?: string;
  isRequired?: boolean;
  hasClearButton?: boolean;
  onDateChange?: (date: Moment | null) => void;
  onDateClear?: () => void;
  blockedDateRanges: Array<Object>;
  isDisabled: boolean;
}

const DatePickerComponent: React.FC<DatePickerProps> = ({
  initialDate = null,
  label,
  id,
  name,
  errorMessage = "Error Message",
  isRequired,
  hasClearButton = true,
  onDateChange,
  onDateClear,
  blockedDateRanges,
  isDisabled
}) => {
  const [date, setDate] = useState<Moment | null>(null);
  const [hasInputError, setHasInputError] = useState(false);

  const handleError = (errors: string[]) => {
    const newHasError = errors.length > 0;
    setHasInputError(newHasError);
  };

  const handleDateChange = (momentDateObject: Moment | null) => {
    setDate(momentDateObject);
    if (onDateChange) {
      onDateChange(momentDateObject);
    }
  };

  const handleDateClear = () => {
    setDate(null);
    if (onDateClear) {
      onDateClear();
    }
  };

  const datePickerStyles: React.CSSProperties = isDisabled
    ? { opacity: 0.7 as const, pointerEvents: 'none' as const }
    : {};

  return (
    <div style={datePickerStyles}>
      <DatePicker
        date={date}
        dateInputProps={{
          isRequired: isRequired,
          hasClearButton: hasClearButton,
          onInputClear: handleDateClear,
          hasError: hasInputError,
          onError: handleError,
          disabled: isDisabled || false,
        }}
        id={id}
        label={label}
        name={name}
        onDateChange={handleDateChange}
        allowDaysInPast={true}
        highlightToday={true}
        blockedDateRanges={blockedDateRanges || []}
        dateFormat="MM/DD/YYYY"
      />
    </div>
  );
};

export default DatePickerComponent;
